export default __webpack_public_path__ + "static/media/mainLogo.6eb14edc.png";